import { translate } from '../../../../Internationalization';
import FormErrorMessages from '../../../../../shared/Forms/Messages/FormErrorMessages';
import Loading from '../../../../../shared/Loading';
import NoContent from '../../../../../shared/NoContent';
import Pagination from '../../../../../shared/Pagination';
import React, { useState } from 'react';
import useGetAgentValuations from '../../../../../Hooks/Agent/Getters/useGetAgentValuations/useGetAgentValuations';
import ValuationsContent from './ValuationsContent';
import ValuationsTable from '../ValuationsTable/ValuationsTable';

const STORAGE_TIME_LIMIT =
	process.env.REACT_APP_VALUATION_STORAGE_TIME_LIMIT ?? '180';

/** @returns {JSX.Element} */
export default function LeadsTable() {
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const valuations = useGetAgentValuations(currentPageNumber);

	if (valuations.isGettingData) {
		return (
			<ValuationsContent isGated={true}>
				<Loading />
			</ValuationsContent>
		);
	}

	if (valuations.errorMessage) {
		return (
			<ValuationsContent isGated={true}>
				<FormErrorMessages messages={valuations.errorMessage} />
			</ValuationsContent>
		);
	}

	if (!valuations.data.length) {
		const message =
			'agent.pages.widgets.lead_generation.lead_table.no_leads';

		return (
			<ValuationsContent isGated={true}>
				<div className="-mt-8">
					<NoContent
						message={translate(`${message}.message`)}
						title={translate(
							`${message}.title`,
							STORAGE_TIME_LIMIT
						)}
					/>
				</div>
			</ValuationsContent>
		);
	}

	return (
		<ValuationsContent>
			<React.Fragment>
				<ValuationsTable
					errorMessage={valuations.errorMessage}
					valuations={valuations.data}
				/>

				<Pagination
					currentPageNumber={currentPageNumber}
					lastPageNumber={valuations.lastPageNumber}
					setCurrentPageNumber={setCurrentPageNumber}
				/>
			</React.Fragment>
		</ValuationsContent>
	);
}
